export const res = {
  loadingAudkenniAppTitle: {
    is: 'Fylgstu með Auðkennisappinu',
    en: 'Check your Auðkenni app',
    pl: 'Sprawdź w swoim aplikację Auðkenni',
  } as const,
  loadingAudkenniAppDescription: (code: string) => {
    return {
      is: `Auðkenningarbeiðni var send í Auðkennisappið þitt. Veldu þar kóðann ${code} til að halda áfram.`,
      en: `An authentication request was sent to your Auðkenni app. Select the code ${code} to continue.`,
      pl: `Wniosek o dokonanie identyfikacji został wysłany na Twoją aplikację bankową. Wybierz kod ${code} aby kontynuować.`,
    };
  },
};
